import { useState } from 'react'
import Location from '../Location/Location'
import { 
    Item,
    DateContainer,
    Date,
    Day,
    BodyContainer,
    BodyTitle,
    BodyText,
    BodyLocation,
    LocationIcon,
    LocationText,
    LogoContainer,
    Icon,
    Logo,
} from './Elements'

const ScheduleItem = ({ item }) => {

    const [openedMap, setOpenedMap] = useState(false)

    const handleOpen = () => {
        document.body.style.overflow = "hidden"
        setOpenedMap(!openedMap)
    }

    return (
        <Item>
            <DateContainer>
                <Date>{item.date}</Date>
                <Day>{item.day}</Day>
            </DateContainer>
            <BodyContainer>
                <BodyTitle>{item.title}</BodyTitle>
                {
                    item.details.map(item => {
                        return (
                            <BodyText key={item}>{item}</BodyText>
                        )
                    })
                }
                {
                    item.icon &&
                    <BodyLocation onClick={handleOpen}>
                        <LocationIcon>
                            <Icon src={item.icon} />
                        </LocationIcon>
                        <LocationText>{item.location}</LocationText>
                    </BodyLocation>
                }
                {
                    openedMap &&
                    <Location 
                    iconSrc={item.icon} 
                    openedMap={openedMap} 
                    setOpenedMap={setOpenedMap}
                    lat={item.lat}
                    long={item.long}
                    />
                }
            </BodyContainer>
            <LogoContainer>
                {
                    item.logo &&
                    <Logo src={item.logo} />
                }
            </LogoContainer>
        </Item>
    )
}

export default ScheduleItem